module.exports = __webpack_public_path__ + "img/msg-cancel.88a07597.svg";